// extracted by mini-css-extract-plugin
module.exports = {"container":"Announcement_container__Th3nh","message":"Announcement_message__at_RP"};